import { InputNumber, InputNumberProps } from "antd";
import { useMemo, useState } from "react";
import styled from "styled-components";
import { priceShorten } from "../../helpers/priceFormat";

interface Props extends InputNumberProps {
	isShortenUnclick?: boolean;
	prefix?: string;
}

const InputPrice: React.FC<Props> = ({ isShortenUnclick, value, prefix, type, ...rest }) => {
	const [isFocus, setIsFocus] = useState<boolean>(false);

	const valueFormated = useMemo(() => {
		const addCommas = (num: any) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		const removeNonNumeric = (num: any) => num.toString().replace(/[^0-9]/g, "");

		if (isFocus || !value || !isShortenUnclick) {
			return rest.name === "sellingPrice" ? addCommas(removeNonNumeric(value ?? 0)) : value;
		}

		return rest.name === "sellingPrice" ? priceShorten(Number(addCommas(removeNonNumeric(value ?? 0)))) : value;
	}, [value, isFocus, isShortenUnclick, rest.name]);
	// default: no controls. Remove this if the space
	// caused by the invisible controls is acceptable
	rest.controls = useMemo(() => (rest.controls ? rest.controls : false), [rest.controls]);

	return rest.name === "sellingPrice" ? (
		<StyledInputNumber
			onFocus={() => setIsFocus(true)}
			onBlur={() => setIsFocus(false)}
			prefix={prefix === undefined ? "Rp" : prefix !== null && prefix !== "" ? prefix : undefined}
			className="full-width"
			parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
			value={valueFormated}
			{...rest}
			onKeyPress={(event) => {
				if (!/[0-9]/.test(event.key)) {
					event.preventDefault();
				}
			}}
		/>
	) : (
		<StyledInputNumber
			onFocus={() => setIsFocus(true)}
			onBlur={() => setIsFocus(false)}
			prefix={prefix === undefined ? "Rp" : prefix !== null && prefix !== "" ? prefix : undefined}
			className="full-width"
			formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
			parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
			value={valueFormated}
			{...rest}
			onKeyPress={(event) => {
				if (!/[0-9]/.test(event.key)) {
					event.preventDefault();
				}
			}}
		/>
	);
};

const StyledInputNumber = styled(InputNumber)`
	.ant-input-number-input-wrap {
		padding-right: ${({ controls }) => (controls !== false ? "33px" : "11px")};
	}
	.ant-input-number-input-wrap > input.ant-input-number-input {
		text-align: right;
	}
`;

export default InputPrice;
